import Avatar from "../../assets/img/avatars/01.jpg";
import React, { useContext,useEffect, useState } from "react";
import { fetchCurrentUserInfo } from "../../_services/userService";
import { updateUserInfo } from "../../_services/userService";
import { ToastContext } from "../../context/ToastContext";
import { AuthContext } from "../../context/AuthContext";

function PersonalInfo() {
  const [userInfo, setUserInfo] = useState({
    fullName: "",
    email: "",
    phoneNumber: "",
    address: "",
    image_url: ""
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [editableFields, setEditableFields] = useState({
    address: false,
    fullName: false,
    phoneNumber: false,
  });
  const [originalData, setOriginalData] = useState({});
  const { showToast } = useContext(ToastContext);
  const { isLoggedIn, logout, updateUserInformation, updateAvatar } = useContext(AuthContext); 

  const handleInputChange = (field, value) => {
    setUserInfo((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const toggleEdit = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  // Reset to original data when cross button is clicked
  const resetToOriginal = (field) => {
    setUserInfo((prev) => ({
      ...prev,
      [field]: originalData[field],
    }));
    toggleEdit(field); // Close input field and revert
  };

  // Save changes and disable the input field when right button is clicked
  const saveChanges = async (field) => {
    try {
      
      const apiFieldMap = {
        fullName: "name",
        phoneNumber: "phone_number",
        email: "email",
        address: "address",
      };
  
      const apiField = apiFieldMap[field];
      const updatedData = { [apiField]: userInfo[field] };
  
      await updateUserInformation(updatedData); // Call API to save changes
  
      setOriginalData((prev) => ({
        ...prev,
        [field]: userInfo[field],
      }));
      toggleEdit(field);
      showToast("Successfully updated");
    } catch (err) {
      showToast("Failed to update the information.", "danger");
     
    }
  };

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const data = await fetchCurrentUserInfo();
        setUserInfo({
          fullName: data.name || "Not specified",
          email: data.email || "Not specified",
          phoneNumber: data.phone_number || "Not specified",
          address: data.address || "Not specified",
          image_url: data.image_url || Avatar
        });
        setOriginalData({
          fullName: data.name || "Not specified",
          email: data.email || "Not specified",
          phoneNumber: data.phone_number || "Not specified",
          address: data.address || "Not specified",
          image_url: data.image_url || Avatar
        });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUserInfo();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="container pb-lg-4 mb-sm-2">
  
      <div className="row mt-4">
        <div className="col-lg-8 col-md-7 mb-5">
          <h1 className="h2">Personal Info</h1>
          <div className="progress mb-4" style={{ height: ".25rem" }}></div>
          <div className="row pt-2">
            <div className="col-lg-9 col-md-12 col-sm-8 mb-2 mb-m-4">
              <div className="border rounded-3 p-3 mb-4" id="personal-info">
                {/* Full name */}
                <div className="border-bottom pb-3 mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="pe-2 opacity-70 w-100">
                      <label className="form-label fw-bold">Full name</label>
                      {!editableFields.fullName ? (
                        <div id="name-value">{userInfo.fullName}</div>
                      ) : (
                        <input
                          className="form-control mt-3"
                          type="text"
                          value={userInfo.fullName}
                          onChange={(e) => handleInputChange("fullName", e.target.value)}
                        />
                      )}
                    </div>
                    <div data-bs-toggle="tooltip" title="Edit">
                      <a
                        className="nav-link py-0"
                        href="#name-collapse"
                        data-bs-toggle="collapse"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleEdit("fullName");
                        }}
                      >
                        <i className="fi-edit"></i>
                      </a>
                    </div>
                  </div>
                  {editableFields.fullName && (
                     <div className="mt-2 d-flex justify-content-end">
                     <button
                       className="btn btn-success btn-sm me-2 rounded-circle"
                       onClick={() => saveChanges("fullName")}
                       style={{ width: "30px", height: "30px", padding: "0" }} 
                     >
                       <i className="fi-check"></i> 
                     </button>
                     <button
                       className="btn btn-danger btn-sm rounded-circle"
                       onClick={() => resetToOriginal("fullName")}
                       style={{ width: "30px", height: "30px", padding: "0" }} 
                     >
                       <i className="fi-x"></i>
                     </button>
                   </div>
                  )}
                </div>

                {/* Email */}
                <div className="border-bottom pb-3 mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="pe-2 opacity-70">
                      <label className="form-label fw-bold">Email</label>
                      <div id="email-value">{userInfo.email}</div>
                    </div>
                  </div>
                </div>

                {/* Phone number */}
                <div className="border-bottom pb-3 mb-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="pe-2 opacity-70 w-100">
                      <label className="form-label fw-bold">Phone number</label>
                      {!editableFields.phoneNumber ? (
                        <div id="phone-value">{userInfo.phoneNumber}</div>
                      ) : (
                        <input
                          className="form-control mt-3"
                          type="text"
                          value={userInfo.phoneNumber}
                          onChange={(e) => handleInputChange("phoneNumber", e.target.value)}
                        />
                      )}
                    </div>
                    <div data-bs-toggle="tooltip" title="Edit">
                      <a
                        className="nav-link py-0"
                        href="#phone-collapse"
                        data-bs-toggle="collapse"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleEdit("phoneNumber");
                        }}
                      >
                        <i className="fi-edit"></i>
                      </a>
                    </div>
                  </div>
                  {editableFields.phoneNumber && (
                    
                    <div className="mt-2 d-flex justify-content-end">
                      <button
                        className="btn btn-success btn-sm me-2 rounded-circle"
                        onClick={() => saveChanges("phoneNumber")}
                        style={{ width: "30px", height: "30px", padding: "0" }} 
                      >
                        <i className="fi-check"></i> 
                      </button>
                      <button
                        className="btn btn-danger btn-sm rounded-circle"
                        onClick={() => resetToOriginal("phoneNumber")}
                        style={{ width: "30px", height: "30px", padding: "0" }} 
                      >
                        <i className="fi-x"></i>
                      </button>
                    </div>
                  )}
                </div>

                {/* Address */}
                <div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="pe-2 opacity-70 w-100">
                      <label className="form-label fw-bold">Address</label>
                      {!editableFields.address ? (
                        <div id="address-value">{userInfo.address}</div>
                      ) : (
                        <input
                          className="form-control mt-2"
                          type="text"
                          value={userInfo.address}
                          onChange={(e) => handleInputChange("address", e.target.value)}
                        />
                      )}
                    </div>
                    <div data-bs-toggle="tooltip" title="Edit">
                      <a
                        className="nav-link py-0"
                        href="#address-collapse"
                        data-bs-toggle="collapse"
                        onClick={(e) => {
                          e.preventDefault();
                          toggleEdit("address");
                        }}
                      >
                        <i className="fi-edit"></i>
                      </a>
                    </div>
                  </div>
                  {editableFields.address && (
                    <div className="mt-2 d-flex justify-content-end">
                      <button
                        className="btn btn-success btn-sm me-2 rounded-circle"
                        onClick={() => saveChanges("address")}
                        style={{ width: "30px", height: "30px", padding: "0" }} 
                      >
                        <i className="fi-check"></i> 
                      </button>
                      <button
                        className="btn btn-danger btn-sm rounded-circle"
                        onClick={() => resetToOriginal("address")}
                        style={{ width: "30px", height: "30px", padding: "0" }} 
                      >
                        <i className="fi-x"></i>
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-12 col-sm-4 mb-4"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PersonalInfo;
